import { Component, Input } from '@angular/core';
import {
	DoubleBookingParsedEvent,
	DoubleBookingParsedInfo
} from '@models/double-booking.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DoubleBookingService } from '@services/double-booking/double-booking.service';
import { SNModalService } from '@web-services/modal/snModal.service';
import { ConfirmGeneralModalComponent } from '@web-components/common/confirm-general-modal/confirm-general-modal.component';
import { AlertAction } from '@models/models';
import { PlatformLocation } from '@angular/common';

@Component({
	selector: 'double-booking-details',
	template: require('./double-booking-details-modal.html'),
	styles: [require('./double-booking-details-modal.scss')]
})
export class DoubleBookingDetailsModalComponent {
	@Input() doubleBookingInfo: DoubleBookingParsedInfo;
	companiesList: Array<string> = [];

	constructor(
		private activeModal: NgbActiveModal,
		private doubleBookingService: DoubleBookingService,
		private modalService: SNModalService,
		private location: PlatformLocation
	) {
		location.onPopState(() => this.onDismiss());
	}

	ngOnInit(): void {
		this.companiesList = this.doubleBookingService.sortBrands(
			Object.keys(this.doubleBookingInfo.events),
			this.doubleBookingInfo
		);
	}

	reactToEventClick(event: DoubleBookingParsedEvent): void {
		const { OPEN_TAB } = event.actions;
		if (OPEN_TAB) {
			const { method, url, alertMessage } = OPEN_TAB;

			if (method === 'NEW_WINDOW') {
				window.open(url, '_blank');
			}

			if (method === 'ALERT_MODAL') {
				this.openAlertModal(alertMessage);
			}
		}
	}

	onDismiss(): void {
		this.activeModal.dismiss();
	}

	private openAlertModal(alert: AlertAction): void {
		const { message, title } = alert;
		const modal = this.modalService.openModal(ConfirmGeneralModalComponent, {
			windowClass: 'ng-bootstrap-modal modal-visible modal-narrow'
		});

		if (title) {
			modal.componentInstance.title = title;
		}

		modal.componentInstance.text = message;

		modal.componentInstance.buttons = [
			{
				text: 'Got it',
				action: 'CLOSE',
				color: 'default',
				size: 'lg'
			}
		];
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/common/double-booking/double-booking-details/double-booking-details-modal.ts